import { render, staticRenderFns } from "./zxns.vue?vue&type=template&id=9c9bda04&scoped=true"
import script from "./zxns.vue?vue&type=script&lang=js"
export * from "./zxns.vue?vue&type=script&lang=js"
import style0 from "./zxns.vue?vue&type=style&index=0&id=9c9bda04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9bda04",
  null
  
)

export default component.exports